// 不需要顯示step的路徑
import { routesLoan } from './aplCatlPon4300';

export default [...routesLoan];
